import { createFileRoute } from "@tanstack/react-router";
import { ComingSoon } from "@client/components/coming-soon";

export const Route = createFileRoute("/_app/settings/database")({
  component: () => <ComingSoon />,
});
